.header {
  display: grid;
  /* Column 1 reserves a stable slot for the hamburger so toggling its
     visibility (priority+ overflow) can't change the nav column's width
     and feed back into ResizeObserver, which previously caused the
     whole page to flicker at widths near the priority+ boundary. */
  grid-template-columns: 32px max-content 1fr max-content;
  align-items: center;
  gap: var(--space-5);
  /* 1.68x the previous vertical padding so the bar reads taller and more
     architectural without changing the logo or grid columns. */
  padding: calc(var(--space-4) * 1.748) var(--space-6);
  background: #1f1b18;
  color: #f2ede7;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.12em;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.22), 0 1px 0 rgba(0, 0, 0, 0.08);
  position: relative;
  z-index: 10;
}

.menuBtn {
  /* Always occupies its grid cell so toggling its visibility never
     changes the nav column's width. Hidden via visibility, not display. */
  display: inline-flex;
  visibility: hidden;
  background: transparent;
  border: 0;
  color: inherit;
  padding: 6px;
  cursor: pointer;
  align-items: center;
  justify-content: center;
}

/* When ResponsiveNav reports overflow, the hamburger appears on
   desktop too so dropped items are still reachable via the drawer. */
.menuBtnForce { visibility: visible !important; }

.logo {
  min-width: max-content;
  display: inline-flex;
  align-items: center;
  font-family: var(--font-display);
  font-size: 1.1rem;
  letter-spacing: 0.2em;
}

.logo img {
  height: 1.68rem;
  width: auto;
  display: block;
  flex-shrink: 0;
}

/* Single-row, no-wrap nav. The measurement mirror computes natural
   widths without affecting layout; the visible row only renders items
   that fit. ResponsiveNav sets the visible-prefix count and toggles
   the parent's hamburger when items are dropped. */
.nav {
  position: relative;
  display: flex;
  justify-content: center;
  gap: var(--space-5);
  flex-wrap: nowrap;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
}

.navMeasure {
  position: absolute;
  inset: 0 auto auto 0;
  display: flex;
  gap: var(--space-5);
  flex-wrap: nowrap;
  visibility: hidden;
  pointer-events: none;
  white-space: nowrap;
}

.navItem {
  color: inherit;
  opacity: 0.92;
  font-size: 0.88rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  transition: opacity 120ms ease, color 120ms ease;
  white-space: nowrap;
  flex: 0 0 auto;
}

.navItem:hover { opacity: 1; color: var(--color-ember); }

.utility {
  display: flex;
  align-items: center;
  gap: var(--space-4);
  font-size: 0.65rem;
  opacity: 0.85;
  min-width: 0;
  flex-wrap: nowrap;
  justify-content: flex-end;
}

.utilityItem {
  white-space: nowrap;
  background: transparent;
  border: 0;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
  padding: 0;
}

@media (max-width: 900px) {
  .header {
    grid-template-columns: max-content 1fr max-content;
    gap: var(--space-3);
    padding: 12px var(--space-4);
  }
  .menuBtn { visibility: visible; }
  .nav { display: none; }
  .logo {
    justify-self: center;
    font-size: 0.95rem;
  }
  .logo img { height: 1.4rem; }
  .utility {
    justify-content: flex-end;
    gap: var(--space-3);
    font-size: 0.62rem;
  }
}

@media (max-width: 540px) {
  /* Strip the utility row down to just cart on small phones — search
     and account live in the drawer. */
  .utility .utilityItem:not(:nth-last-child(-n+1)) { display: none; }
}
